import parseDecimalNumber from 'parse-decimal-number';

class Formatter {
    locale = 'de-De';
    currency = 'EUR';

    /**
     * remove all not number characters
     *
     * @param {string} value
     * @returns
     */
    public getNumberString = (value: string | number): string => {
        if (typeof value === 'number') {
            return value.toLocaleString(this.locale);
        }
        return value ? this.parseLocaleNumber(value, this.locale, this.currency).toLocaleString(this.locale) : '0';
    };

    public getEuroCentString = (value: string | number): string => {
        if (typeof value !== 'number') {
            value = parseDecimalNumber(value ? value : '0', '.,');
        }
        const style = { style: 'currency', currency: this.currency };
        return value > 0 ? value.toLocaleString(this.locale, style) : '';
    };

    public getEuroString = (value: string | number): string => {
        if (typeof value !== 'number') {
            value = parseDecimalNumber(value ? value : '0', '.,');
        }
        return value > 0 ? value.toLocaleString(this.locale, { style: 'currency', currency: this.currency }).replace(',00', '') : '';
    };

    public getFloat = (value: string | number): number => {
        if (typeof value === 'number') {
            return value;
        }
        // return parseDecimalNumber(value ? value.replace(/[^\d,-]/g, '') : '', '.,') || 0;
        return this.parseLocaleNumber(value, this.locale, this.currency);
    };

    protected parseLocaleNumber(stringNumber: string, locale: string, currency_code: string) {
        let num = 123456.789,
            fmt_local = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency_code,
            }),
            parts_local = fmt_local.formatToParts(num),
            group = '',
            decimal = '',
            currency = '';

        // separators
        parts_local.forEach(function (i) {
            switch (i.type) {
                case 'group':
                    group = i.value;
                    break;
                case 'decimal':
                    decimal = i.value;
                    break;
                case 'currency':
                    currency = i.value;
                    break;
                default:
                    break;
            }
        });

        return parseFloat(
            stringNumber
                .replace(new RegExp('\\' + group, 'g'), '')
                .replace(new RegExp('\\' + decimal), '.')
                .replace(new RegExp('\\' + currency, 'g'), '')
        );
    }
}

export default new Formatter();
